(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    const enhanceAteReviewCount = (scope = document) => {
    const selectors = [
      '#customer-feedback',
      '#ate-review-form',
      '#judgeme_product_reviews',
      '.jdgm-review-widget',
      '#shopify-product-reviews',
      '.spr-reviews',
      '[data-product-reviews]',
      '[data-reviews-section]'
    ];

    scope.querySelectorAll('.rating-wrapper .rating-count').forEach((count) => {
      if (count.dataset.ateReviewLinked === 'true') return;

      let target = null;
      for (const selector of selectors) {
        target = document.querySelector(selector);
        if (target) break;
      }

      if (!target) return;

      count.dataset.ateReviewLinked = 'true';
      count.classList.add('ate-rating-count--clickable');
      count.setAttribute('role', 'link');
      count.setAttribute('tabindex', '0');

      const goToReviews = () => target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      count.addEventListener('click', goToReviews);
      count.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          goToReviews();
        }
      });
    });
  };

  enhanceAteReviewCount();
  document.addEventListener('shopify:section:load', (event) => enhanceAteReviewCount(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["text"] && !Shopify.designMode) return;
  try {
    const syncAtePdpTrustBoxesToAddButton = (scope = document) => {
    scope
      .querySelectorAll(
        '.product-information .product-details .ate-shipping-box, .product-information .product-details .ate-dealer-status, .product-information .product-details .ate-guarantee-box, .product-information .product-details .ate-ach-box'
      )
      .forEach((box) => {
        const details = box.closest('.product-details');
        const buyButtons = details?.querySelector('.buy-buttons-block');
        const addButton = buyButtons?.querySelector('.add-to-cart-button');

        if (!details || !buyButtons || !addButton) return;

        const update = () => {
          if (window.innerWidth < 990) {
            box.style.width = '';
            box.style.maxWidth = '';
            box.style.marginInlineStart = '';
            return;
          }

          const boxRect = box.getBoundingClientRect();
          const addRect = addButton.getBoundingClientRect();
          const alignedWidth = Math.max(0, addRect.right - boxRect.left);

          box.style.marginInlineStart = '0px';
          box.style.width = alignedWidth + 'px';
          box.style.maxWidth = alignedWidth + 'px';
        };

        update();

        if (box.dataset.ateCtaAligned !== 'true') {
          const observer = new ResizeObserver(update);
          observer.observe(buyButtons);
          observer.observe(addButton);
          box.dataset.ateCtaAligned = 'true';
        }
      });
  };

  syncAtePdpTrustBoxesToAddButton();
  window.addEventListener('resize', () => syncAtePdpTrustBoxesToAddButton());
  document.addEventListener('shopify:section:load', (event) =>
    syncAtePdpTrustBoxesToAddButton(event.target)
  );

  let ateProductTabsCounter = 0;

  const normalizeAteTabHeading = (value) =>
    value.trim().toLowerCase().replace(/\s+/g, ' ');

  const initAteProductTabs = (scope = document) => {
    scope.querySelectorAll('.product-information .product-details .rte').forEach((container) => {
      if (container.dataset.ateProductTabs === 'true') return;

      const headings = Array.from(container.querySelectorAll('h2, h3'));
      const featuresHeading = headings.find(
        (heading) => normalizeAteTabHeading(heading.textContent) === 'key features'
      );
      const specsHeading = headings.find((heading) =>
        /^(sample )?specifications?$/.test(normalizeAteTabHeading(heading.textContent))
      );

      if (!featuresHeading || !specsHeading || featuresHeading.parentElement !== specsHeading.parentElement) return;

      const parent = featuresHeading.parentElement;
      const featureNodes = [];
      const specNodes = [];

      let current = featuresHeading.nextSibling;
      while (current && current !== specsHeading) {
        const next = current.nextSibling;
        featureNodes.push(current);
        current = next;
      }

      current = specsHeading.nextSibling;
      while (current) {
        const isBoundary =
          current.nodeType === 1 &&
          (current.matches('details') || current.matches('h2, h3'));

        if (isBoundary) break;

        const next = current.nextSibling;
        specNodes.push(current);
        current = next;
      }

      if (!featureNodes.length || !specNodes.length) return;

      ateProductTabsCounter += 1;
      const baseId = `ate-product-tabs-${ateProductTabsCounter}`;

      const wrapper = document.createElement('div');
      wrapper.className = 'ate-product-tabs';

      const tabList = document.createElement('div');
      tabList.className = 'ate-product-tabs__nav';
      tabList.setAttribute('role', 'tablist');
      tabList.setAttribute('aria-label', 'Product details');

      const featuresTab = document.createElement('button');
      featuresTab.type = 'button';
      featuresTab.className = 'ate-product-tabs__tab';
      featuresTab.id = `${baseId}-features-tab`;
      featuresTab.setAttribute('role', 'tab');
      featuresTab.setAttribute('aria-selected', 'true');
      featuresTab.setAttribute('aria-controls', `${baseId}-features-panel`);
      featuresTab.textContent = 'Key Features';

      const specsTab = document.createElement('button');
      specsTab.type = 'button';
      specsTab.className = 'ate-product-tabs__tab';
      specsTab.id = `${baseId}-specs-tab`;
      specsTab.setAttribute('role', 'tab');
      specsTab.setAttribute('aria-selected', 'false');
      specsTab.setAttribute('aria-controls', `${baseId}-specs-panel`);
      specsTab.setAttribute('tabindex', '-1');
      specsTab.textContent = 'Specifications';

      const featuresPanel = document.createElement('div');
      featuresPanel.className = 'ate-product-tabs__panel';
      featuresPanel.id = `${baseId}-features-panel`;
      featuresPanel.setAttribute('role', 'tabpanel');
      featuresPanel.setAttribute('aria-labelledby', featuresTab.id);

      const specsPanel = document.createElement('div');
      specsPanel.className = 'ate-product-tabs__panel';
      specsPanel.id = `${baseId}-specs-panel`;
      specsPanel.setAttribute('role', 'tabpanel');
      specsPanel.setAttribute('aria-labelledby', specsTab.id);
      specsPanel.hidden = true;

      featureNodes.forEach((item) => featuresPanel.appendChild(item));
      specNodes.forEach((item) => specsPanel.appendChild(item));

      parent.insertBefore(wrapper, featuresHeading);
      featuresHeading.remove();
      specsHeading.remove();

      tabList.append(featuresTab, specsTab);
      wrapper.append(tabList, featuresPanel, specsPanel);

      const tabs = [featuresTab, specsTab];
      const panels = [featuresPanel, specsPanel];

      const activateTab = (index, moveFocus = false) => {
        tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === index;
          tab.setAttribute('aria-selected', String(isActive));
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
          panels[tabIndex].hidden = !isActive;
        });

        if (moveFocus) tabs[index].focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(index));

        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;

          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          if (nextIndex !== index) {
            event.preventDefault();
            activateTab(nextIndex, true);
          }
        });
      });

      container.dataset.ateProductTabs = 'true';
    });
  };

  initAteProductTabs();
  document.addEventListener('shopify:section:load', (event) => initAteProductTabs(event.target));
  } catch(e) { console.error(e); }
})();

})();
